// src/components/GoogleIcon.jsx
export const GoogleIcon = () => (
  <span style={{ marginRight: 8 }}>🔗</span>
);
